<template>
<div id="statement">
    <header>施维雅中国社交媒体平台法律声明</header>
    <h2>1.接受</h2>
    <p>您必须按照以下条款、条件以及相关法律法规访问和使用本社交媒体平台。访问和使用本社交媒体平台意味着您无限制和无条件地接受本文的全部条款与条件，并承认您和施维雅（天津）制药有限公司（以下简称“施维雅”）之间关于访问和使用本社交媒体平台的任何其它协议均由本文取代而失去效力。</p>
    <h2>2.医疗信息/条件</h2>
    <p>本社交媒体平台的产品信息(如有)，只用于一般信息交流目的，且并不完整。社交媒体平台下的任何内容和信息在任何情况下均不构成对任何人士的任何指导，亦不构成对任何医药产品或服务的商业推广或广告宣传。我们不提供个人医疗诊断或特定患者治疗建议。请勿参考或依赖本社交媒体平台下的任何内容。有关疾病或药品的相关问题，请您咨询您的医生或有资质的医疗专业人员。您应该随时通过与您的处方医生或其他医疗顾问直接讨论药物或医疗器械的适当使用方法，来获得关于您的处方药或医疗器械的完整医疗信息(包括其有益疗效及可能的不良影响)。医疗专业人士可从产品信息手册获得完整医疗信息。关于这些产品的信息在不同国家可能有所不同。另外，许多国家当前的规定限制（甚至禁止）施维雅直接向患者提出的关于处方产品的问题提供信息和/或回应。在该情况下，施维雅将按照当地法律法规的规定向有资质的医疗专业人士提供答复。</p>
    <h2>3.信息的使用</h2>
    <p>您可以自由访问和使用本社交媒体平台，但是您访问和使用的本社交媒体平台中的信息，包括任何文字、图像、声频和视频（统称为“信息”），仅可用于个人而非商业用途。未经施维雅事先书面许可，不得发布、修改、传播、再利用、转载或将信息用于商业目的。您必须保留及复制下载的任何信息中包含的全部版权声明或其它权利声明。您在本社交媒体平台所看到或读到的所有内容均有版权，除非另有说明，未经施维雅书面许可，您不得使用前述所有内容。施维雅不保证、亦未表示您使用本社交媒体平台的资料不会侵犯不属于施维雅或与施维雅无关联的第三方权利。除以上有限授权外，您没有被授予或转让任何信息的特许权或其他权利、或任何施维雅或其它任何方的版权。</p>
    <p>本社交媒体平台不是向施维雅报告药品不良事件和进行产品投诉的正当平台。如果您有针对药品的不良事件报告请直接联系010-65612775转170/156/116或+86 186-1141-1369；如果有关施维雅产品医学信息咨询，请拨打：010-65610341转141/337/651或+86 18518266365。</p>
    <h2>4.商标/专有权利</h2>
    <p>本社交媒体平台出现的商标，无论是否有注册商标标识，均为商标权利人的商标。本社交媒体平台还可能包含或引述施维雅和/或其它方的专利、专有信息、技术、产品、工艺或其它专有权利。您没有被授权或转让任何施维雅和/或其它方的此类商标、专利、商业机密、技术、产品、工艺或其它专有权利。</p>
    <h2>5.弃权保证</h2>
    <p>即便施维雅尽合理努力来确保信息是正确和最新的，该等信息也可能含有技术上的不准确或文字错误。施维雅保留随时对信息、以及信息中描述的产品与程序进行更改、更正和/或改进的权利，而无需通告。施维雅对任何信息的准确性或完整性不做任何陈述或保证。施维雅对本社交媒体平台内容的任何错误或疏忽亦不承担任何责任。全部信息照“原样”提供。施维雅对本社交媒体平台信息的完整性或准确性或其可能的用途不提供保证。因此，访问者应自行认真评估信息并承担相应风险。施维雅、任何其它施维雅集团公司或任何与本社交媒体平台的创作、制作或发布有关的其它方，对于因访问、使用或不能使用本社交媒体平台、或因本社交媒体平台内容的任何错误或疏忽引起的任何直接的、偶然的、后果性的、间接的或惩罚性的损失均不承担任何责任。对于因您访问和使用信息而导致的您的财产损失或病毒感染，施维雅不承担任何责任。施维雅保留随时停止本社交媒体平台运行的权利而无需通告且不承担任何责任。
    </p>
    <h2>6.您提供给我们的信息</h2>
    <p>除施维雅隐私政策涵盖的信息之外，您通过本社交媒体平台提供的任何沟通或资料，包括任何数据、提问、意见、建议或此类内容，均将被视为非机密和非专有信息。您提交或张贴的任何内容将成为施维雅或其关联方的资产，并且可用于任何目的，包括但不限于复制、披露、传播、公布、广播及张贴。进而，施维雅可自由使用包含在您提交给本社交媒体平台的任何内容中的创意、概念、技术或方法用于任何目的，包括但不限于使用此类信息开发、制造和销售产品，而无需给您补偿。</p>
    <h2>7.全球产品</h2>
    <p>本社交媒体平台可能包含关于全球产品和服务的信息，但并非在所有地方均可获得。本社交媒体平台提及某产品或服务并不暗示该产品或服务在您的所在地区可以获取。本社交媒体平台提及的产品按使用国家可属于不同的法规要求。因此访问者应理解本社交媒体平台的某些部分仅适于某些类型的专家使用者或仅适于某些国家的受众。您不应将本社交媒体平台的任何内容解释为在您所居住国家的法律和法规不允许的产品或产品用法的推广或广告。</p>
    <h2>8.与本社交媒体平台的链接</h2>
    <p>施维雅未审核过任何或全部含有与本社交媒体平台链接的第三方网站或者第三方社交媒体平台，因此对此类非本社交媒体平台或者其他相关链接的网站或平台的内容不承担任何责任。如果您希望加入本社交媒体平台，您须同意并严格遵守上述规定并按照施维雅要求加入。未经施维雅书面同意，禁止在第三方网站或其它社交媒体平台中引用或使用本社交媒体平台中一个或多个部分。</p>
    <h2>9.与其它网站的链接</h2>
    <p>为本社交媒体平台访问者的兴趣或方便可提供与第三方网站的链接。当您离开本社交媒体平台时，我们将尽力告知您第三方网站的使用条款和隐私政策可能不同。但是，施维雅对本社交媒体平台上提供的第三方网站的链接，尤其是其中内容和准确性或合法性不承担任何责任。施维雅对访问者对第三方网站隐私政策中的违约或违反亦不承担任何责任。</p>
    <h2>10.在本社交媒体平台张贴</h2>
    <p>尽管施维雅会随时监控或审核本社交媒体平台上的讨论、聊天、帖子、转载、公告牌及同类内容，但施维雅对本社交媒体平台任何位置中的任何信息所包含的错误、诽谤、侮辱、谤毁、疏忽、谬误、淫秽、色情、亵渎、危险、隐私披露或不准确性不承担任何责任与义务。同时我们禁止张贴或转载任何非法、威胁、谤毁、诽谤、淫秽、色情、煽动性、或亵渎性的内容、或任何可能构成或鼓励被认为犯罪行为、导致民事责任或其它违反法律行为的内容。施维雅将全力配合任何执法机构或法庭命令、要求或指令披露任何张贴此类信息或内容的个人的身份。
    </p>
    <h2>11.后果</h2>
    <p>如果我们获知您违反了本法律声明中含有的任何条款与条件，我们可随时立即采取更正行动，包括防止您使用施维雅提供的服务，并删除您在本社交媒体平台上放置的任何信息、数据和内容，而无需通告。如果由于您的行为给我方造成损失，我们有权自行决定是否要求您赔偿损失。</p>
    <h2>12.修改</h2>
    <p>施维雅可随时通过更新本文修改该条款与条件。任何此类修改对您均有约束力，因此您应该定期访问本页查看当前对您有约束力的条款与条件。</p>
    <h2>13.隐私声明</h2>
    <p>本社交媒体平台不需要任何注册，您可以访问而无需告诉我们您的身份或提交个人信息。施维雅非常重视保护访问/使用者的隐私信息。如果您主动通过本社交媒体平台传递给我们某些个人信息，即表明您同意施维雅使用和处理您提供的信息，相关信息将会被适当处理（包含合理的内部使用），且不会用于您提供信息时明确的相关目的之外的其他用途。施维雅会采取必要的措施，保护您的信息安全。</p>

</div>
</template>

<script>
export default {
    data() {
        return {

        }
    },
    created() {},
    methods: {}
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
#statement {
    padding: 20px;
    header {
        font-size: 32px;
        text-align: center;
        font-weight: bolder;
    }
    h2 {
        font-size: $font-size;
        line-height: 80px;
    }
    p {
        font-size: $font-size;
        line-height: $line-height;
        margin-bottom: $margin-btm;
    }
}
</style>
